export enum SchedulesEnum {
  PartTime = 'PART_TIME',
  FullTime = 'FULL_TIME',
  UNKNOWN = 'UNKNOWN',
}

export enum LocationsEnum {
  AgencyNetwork = 'AGENCY',
  HQ = 'HQ',
}

export enum SectorsEnum {
  MARKETING = 'MARKETING',
  BANKING = 'BANKING',
  DATA = 'DATA',
  FINANCE = 'FINANCE',
  IT = 'IT',
  AGENCIES = 'AGENCIES',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  CREDITS = 'CREDITS',
  LEGAL = 'LEGAL',
  PROCESS_MANAGEMENT = 'PROCESS_MANAGEMENT',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  SALES_DISTRIBUTION = 'SALES_DISTRIBUTION',
  INSURANCES = 'INSURANCES',
  INTERNSHIP = 'INTERNSHIP',

  // Old API only
  SUPPORTING_SERVICES = 'SUPPORTING_SERVICES',
  TRAINEESHIP = 'TRAINEESHIP',

  // New API only
  INVESTING = 'INVESTING',
  DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
  COMMUNICATION = 'COMMUNICATION',
  RISK = 'RISK',
  HR = 'HR',
  LEADERSHIP = 'LEADERSHIP',
  COMMERCIAL = 'COMMERCIAL',
  STARTER = 'STARTER',
}
